<template>
  <div class="publicReadingTreasure">
    <!-- <Title
      :datas="[{ text: '阅宝落地页', id: 123 }]"
      :active="123"
    /> -->
    <div class="publicReadingTreasure_xuanz">
      <el-button
        type="primary"
        @click="isPopup = 'establish'"
      >创建阅宝落地页</el-button>
    </div>
    <div class="publicReadingTreasure_main">
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column
          label="落地页名称"
          prop="page_name"
          width="150"
        >
          <template slot-scope="scope">
            <div
              style="display: flex;flex-direction: column;"
            >
              <span>{{ scope.row.page_name }}</span>
              <span>ID: {{ scope.row.page_id }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="小说书名"
          prop="novel_name"
          width="150"
        />
        <el-table-column
          label="类型"
          width="150"
        >
          <template>
            <span>公众号</span>
          </template>
        </el-table-column>
        <el-table-column
          label="创建日期"
          width="150"
        >
          <template slot-scope="scope">
            <span>{{ intercept(scope.row.created_at,'T') }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="状态"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.status === 'LANDING_PAGE_STATUS_EDITING' ? '草稿' : scope.row.status === 'LANDING_PAGE_STATUS_PENDING' ? '待送审' : scope.row.status === 'LANDING_PAGE_STATUS_UNPUBLISH' ? '审核不通过' :scope.row.status === 'LANDING_PAGE_STATUS_PUBLISHED' ? '已发布' : '' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="300"
        >
          <template slot-scope="scope">
            <div class="operationArea">
              <el-button
                v-if="scope.row.status === 'LANDING_PAGE_STATUS_PUBLISHED'"
                type="text"
                size="small"
                @click="(activeItem = scope.row),(isPopup = 'promotionLink')"
              >推广链接</el-button>
              <el-button
                type="text"
                size="small"
                @click="(activeItem = scope.row),(isPopup = 'copyPopup')"
              >复制</el-button>
              <el-button
                type="text"
                size="small"
                @click="(activeItem = scope.row),(isPopup = 'preview')"
              >预览</el-button>
              <el-button
                v-if="scope.row.status === 'LANDING_PAGE_STATUS_EDITING'"
                type="text"
                size="small"
                @click="submitForCensorship(scope.row)"
              >送审</el-button>
              <el-button
                type="text"
                size="small"
                @click="deleteClick(scope.row)"
              >删除</el-button>
              <el-button
                type="text"
                size="small"
                @click="onlyViewClick(scope.row)"
              >查看</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="publicReadingTreasure_page">
      <el-pagination
        layout="prev, pager, next"
        :total="count"
        @current-change="paginChange"
      />
    </div>
    <div v-if="isPopup" class="mengcheng">
      <Popup v-if="isPopup === 'establish'" @close="close" />
      <CopyPopup v-if="isPopup === 'copyPopup'" :active-item="activeItem" @close="close" />
      <Preview v-if="isPopup === 'preview'" :active-item="activeItem" @close="close" />
      <PromotionLink v-if="isPopup === 'promotionLink'" :active-item="activeItem" @close="close" />
    </div>
  </div>
</template>

<script>
/* import Title from '@/components/Title/index.vue' */
import { getLandingPageList1, deleteLandingPage1, submitForCensorship } from '@/api/landingPage.js'
import Popup from './components/popup.vue'
import CopyPopup from './components/copyPopup.vue'
import Preview from './components/preview.vue'
import PromotionLink from './components/promotionLink.vue'
export default {
  components: {
    /* Title, */
    Popup,
    CopyPopup,
    Preview,
    PromotionLink
  },
  data() {
    return {
      tableData: [],
      count: null,
      page: 1,
      loading: true,
      isPopup: null,
      activeItem: null
    }
  },

  async created() {
    this.getList()
  },

  methods: {
    intercept(value, ta) {
      const index = value.indexOf(ta)
      return value.substr(0, index)
    },

    async getList() {
      this.loading = true
      const data = await getLandingPageList1({
        account_id: this.$route.query.account_id,
        page: this.page
      })
      this.loading = false
      this.tableData = data.data.list
      this.count = data.data.count
    },
    onlyViewClick(item) {
      this.$store.commit('landingPage/setCurrentLandingPageData', item)
      this.$router.replace({
        path: '/readTreasure',
        query: { account_id: 'onlyView' }
      })
    },
    async deleteClick(item) {
      this.loading = true
      await deleteLandingPage1({ account_id: this.$route.query.account_id }, item.page_id)
      await this.getList()
      this.$message({
        message: '删除成功',
        type: 'success'
      })
    },
    paginChange(current) {
      this.page = current
      this.getList()
    },
    close(state) {
      if (state) {
        this.getList()
      }
      this.isPopup = null
    },

    async submitForCensorship(item) {
      this.loading = true
      await submitForCensorship({
        account_id: item.account_id,
        page_id: item.page_id
      })
      await this.getList()
      this.loading = false
      this.$message({
        message: '送审成功',
        type: 'success'
      })
    }
  }
}
</script>

<style scoped lang="less">
.publicReadingTreasure{
  width: 90%;
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 30px;

  .publicReadingTreasure_xuanz{
    height: 50px;
    display: flex;
    align-items: center;
    padding: 0px 20px;
    border: 1px solid #e6e8ed;
    /* border-top: none; */
    border-bottom: none;
    border-bottom: 1px solid #e6e8ed;
  }

 .publicReadingTreasure_main{
   border-left: 1px solid #e6e8ed;
    border-right: 1px solid #e6e8ed;
 }

 .publicReadingTreasure_page{
    height: 40px;
    display: flex;
    align-items: center;
    border: 1px solid #e6e8ed;
    /* border-top: none; */
 }

}

.operationArea{
  display: flex;

}

.mengcheng{
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1111;
  top: 0px;
  left: 0px;
  background-color: rgba(0, 0, 0, 0.65);
}

</style>
